import Size from './Size'
import Thick from './Thick'
import Face from './Face'
import Clog from './Clog'

export default class Box {
  public constructor(
    public readonly outer: Size,
    public readonly thick: Thick,
    public readonly face: Face,
    public readonly clampNums: Size,
    public readonly clampSize: Size,
    public readonly clog: Clog
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Box.ts